import React from 'react';
import PropTypes from 'prop-types';
import { ResponsiveBar } from 'cccisd-nivo/bar';
import { round, mean } from 'lodash';

const OverallKeyElementChart = props => {
    const { data, subscales } = props;

    const getData = () => {
        const rows = [];
        const ccmap = {};

        for (const subscale of subscales) {
            const subscaleCcScores = {};

            for (const item of subscale.items) {
                for (const cc of data.flows[item].frequency) {
                    if (cc.value) {
                        if (!ccmap[cc.value]) {
                            ccmap[cc.value] = { keyElms: [], overall: [] };
                        }

                        if (!subscaleCcScores[cc.value]) {
                            subscaleCcScores[cc.value] = [];
                        }

                        if (cc.avg !== null) {
                            subscaleCcScores[cc.value].push(cc.avg);
                        }
                    }
                }
            }

            for (const cc of Object.keys(subscaleCcScores)) {
                if (subscaleCcScores[cc].length === 0) {
                    continue;
                }

                const subscaleAvg = mean(subscaleCcScores[cc]);
                ccmap[cc].overall.push(subscaleAvg);

                if (subscale.keyElement) {
                    ccmap[cc].keyElms.push(subscaleAvg);
                }
            }
        }

        for (const cc of Object.keys(ccmap)) {
            const row = { cc, careCoord: cc.split(', ')[0] };
            row.overall = ccmap[cc].overall.length ? mean(ccmap[cc].overall) * 100 : null;
            row.keyElements = ccmap[cc].keyElms.length ? mean(ccmap[cc].keyElms) * 100 : null;
            rows.push(row);
        }

        let allOverallNull = true;
        let allKeyElmsNull = true;
        const overallTotal = [];
        const keyElmsTotal = [];
        for (const row of rows) {
            if (row.overall !== null) {
                allOverallNull = false;
                overallTotal.push(row.overall);
            }
            if (row.keyElements !== null) {
                allKeyElmsNull = false;
                keyElmsTotal.push(row.keyElements);
            }
        }
        return [
            {
                group: 'Overall TOM 2.0 Score',
                average: allOverallNull ? 0 : round(mean(overallTotal), 2),
            },
            {
                group: 'Key Elements Score',
                average: allKeyElmsNull ? 0 : round(mean(keyElmsTotal), 2),
            },
        ];
    };

    const chartData = getData();

    if (!chartData.length > 0) {
        return (
            <div style={{ width: '770px', height: '300px', textAlign: 'center' }}>
                <h2 style={{ marginTop: '125px' }}>No data</h2>
            </div>
        );
    }

    const longestLabel = Math.max(
        ...chartData.map(o => {
            return o.group.length;
        })
    );

    return (
        <div style={{ width: '770px', height: `${300 + 6.5 * longestLabel}px` }}>
            <ResponsiveBar
                indexBy="group"
                maxValue={100}
                labelFormat={d => <tspan y={-8}>{d}</tspan>}
                labelSkipWidth={0}
                labelSkipHeight={1}
                keys={['average']}
                theme={{ fontSize: 16 }}
                axisBottom={{ tickRotation: 45 }}
                data={chartData}
                margin={{ top: 15, right: 150, bottom: 6.5 * longestLabel, left: 50 }}
            />
        </div>
    );
};

OverallKeyElementChart.propTypes = {
    data: PropTypes.object,
    subscales: PropTypes.array,
};

export default OverallKeyElementChart;
